import React, { useEffect, useState } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  checkPermision,
  formatterStatus,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import { DropdownCustomToggler } from "../../../_metronic/_partials/dropdowns";

export const MonitorTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  dataParams,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1,
      };
    });
    setTableData(initData);
  }, [data]);

  const [tableData, setTableData] = useState(data);

  const columns = [
    // {
    //   text: "No",
    //   dataField: "no",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   style: { minWidth: "150px" },
    // },
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Master Code",
      dataField: "master_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Vehicle Name",
      dataField: "vehicle_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Model Code",
      dataField: "model_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Color Code",
      dataField: "color_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Job No.",
      dataField: "job_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "ETD",
      dataField: "etd",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
    {
      text: "ETA",
      dataField: "eta",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatDate,
    },
  ];

  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      console.log(row, "row");
      if (dataParams === "RCI") {
        history.push(`/inbound/workflow/edit/${row.inbound_id}`, 0);
      }
      if (dataParams === "PDI-In") {
        history.push(`/inbound/workflow/edit/${row.inbound_id}`, 1);
      }
      if (dataParams === "PDI-Out") {
        history.push(`/inbound/workflow/edit/${row.inbound_id}`, 2);
      }
      if (dataParams === "Storage") {
        history.push(`/inbound/workflow/edit/${row.inbound_id}`, 3);
      }
      if (dataParams === "Picking") {
        history.push(`/outbound/job/workflow/edit/${row.outbound_id}`, 0);
      }
      if (dataParams === "Handover") {
        history.push(`/outbound/job/workflow/edit/${row.outbound_id}`, 1);
      }
      if (dataParams === "Back To Storage") {
        history.push(`/outbound/job/workflow/edit/${row.outbound_id}`, 2);
      }
      if (dataParams === "Maintenance") {
        history.push(
          `/motor-pool/maintenance/workflow/edit/${row.maintenance_id}`,
          0
        );
      }
      if (dataParams === "Inspection") {
        history.push(
          `/motor-pool/maintenance/workflow/edit/${row.maintenance_id}`,
          1
        );
      }
      if (dataParams === "Re PDI-In") {
        history.push(
          `/motor-pool/maintenance/pdi/workflow/edit/${row.maintenance_id}`,
          0
        );
      }
      if (dataParams === "Re PDI-Out") {
        history.push(
          `/motor-pool/maintenance/pdi/workflow/edit/${row.maintenance_id}`,
          1
        );
      }
      if (dataParams === "Vehicle Information Update") {
        history.push(
          `/motor-pool/info-update/workflow/edit/${row.infoupdate_id}`,
          0
        );
      }
      if (dataParams === "Count") {
        history.push(
          `/motor-pool/stocktake/workflow/edit/${row.stocktake_id}`,
          0
        );
      }
    },
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="inbound_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
        rowEvents={rowEvents}
        noDataIndication="No data to display.   Please do searching to display particular vehicle(s)"
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {/* Footer */}
    </>
  );
};
